// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"97":"d00c1c1b6dd49e88dc23","163":"398e65262408dc82b6b5"}[chunkId] + ".css";
};